(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["free-gift-item"] && !Shopify.designMode) return;
  try {
    function runGiftGrouping() {
  var cards = Array.prototype.slice.call(document.querySelectorAll('.free-gift-card'));

  function getAncestors(node) {
    var arr = [];
    while (node) {
      arr.push(node);
      node = node.parentElement;
    }
    return arr;
  }

  function processGroup(groupCards) {
    if (!groupCards.length) return;

    // Find the closest common ancestor of every card WITHIN THIS GROUP ONLY
    var common = getAncestors(groupCards[0]);
    for (var i = 1; i < groupCards.length; i++) {
      var thisAncestors = getAncestors(groupCards[i]);
      common = common.filter(function (n) { return thisAncestors.indexOf(n) !== -1; });
    }
    var container = common[0];
    if (!container) return;

    // Already grouped (re-run guard)
    if (container.classList && container.classList.contains('free-gift-grid')) return;

    // Find the branch (direct child of container) that leads to the first
    // card in this group, so we insert the new grid in the correct spot.
    var firstBranch = groupCards[0];
    while (firstBranch.parentElement !== container) {
      firstBranch = firstBranch.parentElement;
    }

    var grid = document.createElement('div');
    grid.className = 'free-gift-grid';
    grid.style.setProperty('--gift-count', groupCards.length);
    container.insertBefore(grid, firstBranch);

    // Move each card in this group into the grid. Any now-empty wrapper
    // Shopify added around it is REMOVED entirely (not just left behind)
    // so it can never add unwanted spacing — e.g. when the surrounding
    // section uses a flex/grid layout with a "gap", an empty leftover
    // wrapper still counts as a child and eats up a full gap's worth of
    // space even with nothing visible inside it.
    groupCards.forEach(function (card) {
      var originalParent = card.parentElement;
      grid.appendChild(card);
      removeEmptyAncestors(originalParent, container);
    });

    function removeEmptyAncestors(node, stopAt) {
      while (node && node !== stopAt && node.parentElement) {
        var parent = node.parentElement;
        var isEmpty = node.children.length === 0 && node.textContent.trim() === '';
        if (isEmpty) {
          node.remove();
          node = parent;
        } else {
          break;
        }
      }
    }

    // Heading (agar kisi block mein show_heading ON hai) ko is SAME group's
    // grid se theek pehle move kar do — chahe wo kisi bhi block instance
    // mein ho, taake ye hamesha is group ke cards ke UPAR dikhe, neeche
    // nahi, aur kisi doosre group ki heading se mix na ho.
    var heading = container.querySelector('.free-gift-heading');
    if (heading) {
      container.insertBefore(heading, grid);
    }
  }

  // Group cards by which .shopify-section they belong to, so cards
  // rendered inside DIFFERENT sections on the same page (e.g. the main
  // product page's own Free Gift blocks vs. a separate "Buybox" section's
  // Free Gift blocks) are NEVER merged into one shared grid — each
  // section's gifts stay exactly where they were placed.
  var groups = {};
  var groupOrder = [];
  cards.forEach(function (card) {
    var sectionEl = card.closest('.shopify-section');
    var key = sectionEl ? sectionEl.id : 'no-section-fallback';
    if (!groups[key]) {
      groups[key] = [];
      groupOrder.push(key);
    }
    groups[key].push(card);
  });

  groupOrder.forEach(function (key) {
    processGroup(groups[key]);
  });

  // Final safety sweep: Theme Editor re-renders a section's HTML fresh
  // from the server whenever a block is added/removed/reordered inside
  // it (shopify:section:load), but that fresh HTML doesn't know about
  // any grouping this script already did earlier — so a leftover empty
  // wrapper can occasionally survive a reload. This catches and removes
  // ANY genuinely empty free-gift-item wrapper still left anywhere on
  // the page, regardless of which group/section it belongs to.
  document.querySelectorAll('[id*="free_gift_item"]').forEach(function (el) {
    if (el.children.length === 0 && el.textContent.trim() === '') {
      el.remove();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runGiftGrouping);
} else {
  runGiftGrouping();
}

// Theme Editor: re-run whenever this or another section reloads (e.g.
// after adding/removing/editing a block), so newly-rendered free-gift
// cards get grouped and any stray empty wrappers get cleaned up without
// needing a full page refresh.
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () {
    setTimeout(runGiftGrouping, 0);
  });
}
  } catch(e) { console.error(e); }
})();

})();
